import React, { Fragment } from "react";
import "./loader.css";
import Logo from "../images/output-onlinepngtools-removebg-preview.png";

function loader() {
  return (
    <Fragment>
      <div className="loader-container" role="status" aria-live="polite" aria-label="Loading IM Online Shop">
        <div className="loader-card">
          <div className="loader-logo-shell">
            <span className="loader-ring"></span>
            <img src={Logo} alt="IM Online Shop" />
          </div>
          <div className="loader-copy">
            <strong>IM Online Shop</strong>
            <span>Preparing your shopping experience</span>
          </div>
          <div className="loader-progress" aria-hidden="true">
            <span></span>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default loader;
